import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {localStorageHelper} from '@pluto-tv/assemble';
import decodeJwt from 'jwt-decode';

export interface IUser {
  isAuthenticated: boolean;
  roles?: string[];
  email?: string;
  status?: string;
  name?: string;
  picture?: string;
  jwt?: string;
  regions?: string[];
  // Command Center login user info
  authzUser?: {
    email?: string;
    first_name?: string;
    last_name?: string;
    associated_tenants?: {
      roles?: string[];
    };
  };
}

const userSlice = createSlice({
  name: 'user',
  initialState: {roles: [], isAuthenticated: false} as IUser,
  reducers: {
    login: (state, {payload: {jwt}}: PayloadAction<{jwt: string}>) => {
      if (!jwt) return state;

      const user: Partial<IUser> = decodeJwt(jwt);

      if (user.authzUser) {
        state.roles = user.authzUser?.associated_tenants?.roles;
        state.email = user.authzUser?.email;
        state.name = `${user.authzUser?.first_name} ${user.authzUser?.last_name}`;
      } else {
        state.roles = user.roles;
        state.email = user.email;
        state.name = user.name;
      }

      state.isAuthenticated = true;
      state.status = user.status;
      state.picture = user.picture;
      state.jwt = jwt;
      state.regions = [];

      localStorageHelper.save('Jwt-Token', jwt);
    },
    logout: state => {
      state.isAuthenticated = false;
      state.roles = [];
      state.email = undefined;
      state.status = undefined;
      state.name = undefined;
      state.picture = undefined;
      state.jwt = undefined;
      state.regions = undefined;

      localStorageHelper.remove('Jwt-Token');
    },
    setProfile: (state, {payload: {regions}}: PayloadAction<{regions: string[]}>) => {
      state.regions = regions;
    },
  },
});

export const {login, logout, setProfile} = userSlice.actions;

export default userSlice.reducer;
